import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class AssignClerksSearchModel extends BaseModel {
  lot_no = null
  bidder_uuid = null
  preferred_clerk_uuid = []
  preferred_language_uuid = []
  cover_amount_from = null
  cover_amount_to = null
  assigned_clerk_uuid = []
  show_unassigned_only = false

  static TRANSLATABLE_FIELDS = [];

  rules = {
  };

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    cover_amount_from: i18n.t('Min Cover Amount'),
    cover_amount_to: i18n.t('Max Cover Amount'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

